import App from './intro.svelte'

export default function hydrate(el, props) {
  return new App({
    target: el,
    hydrate: true,
    props,
  })
}
